import React, { useEffect, useState } from "react";
import api from "../lib/api";
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import StatsBar from "../components/StatsBar";
import AboutSection from "../components/AboutSection";
import WhyUsSection from "../components/WhyUsSection";
import TeamSection from "../components/TeamSection";
import MemberOfMonth from "../components/MemberOfMonth";
import WorkshopsSection from "../components/WorkshopsSection";
import AchievementsTimeline from "../components/AchievementsTimeline";
import ContactSection from "../components/ContactSection";
import GoalsSection from "../components/GoalsSection";
import { mergeContent } from "../lib/content";
import GallerySection from "../components/GallerySection";
import PartnersSection from "../components/PartnersSection";
import EasterEgg from "../components/EasterEgg";
import Footer from "../components/Footer";

const SECTIONS = {
  stats: (d) => <StatsBar content={d.content} />,
  about: (d) => <AboutSection settings={d.settings} content={d.content} />,
  why_us: (d) => <WhyUsSection content={d.content} />,
  goals: (d) => <GoalsSection content={d.content} />,
  team: (d) => <TeamSection team={d.team} content={d.content} />,
  mom: (d) => <MemberOfMonth items={d.mom} settings={d.settings} content={d.content} />,
  workshops: (d) => <WorkshopsSection workshops={d.workshops} content={d.content} />,
  achievements: (d) => <AchievementsTimeline items={d.achievements} content={d.content} />,
  contact: (d) => <ContactSection settings={d.settings} content={d.content} />,
  partners: (d) => <PartnersSection partners={d.partners} content={d.content} />,
  gallery: (d) => <GallerySection items={d.gallery} content={d.content} />,
};

export default function HomePage() {
  const [data, setData] = useState({
    settings: null, team: [], mom: [], plays: [], workshops: [], achievements: [], partners: [], gallery: [], content: mergeContent(null),
  });

  useEffect(() => {
    (async () => {
      try {
        const [s, t, m, p, w, a, pr, c, g] = await Promise.all([
          api.get("/settings"),
          api.get("/team"),
          api.get("/members-of-month"),
          api.get("/plays"),
          api.get("/workshops"),
          api.get("/achievements"),
          api.get("/partners"),
          api.get("/content"),
          api.get("/gallery"),
        ]);
        setData({
          settings: s.data,
          team: t.data,
          mom: m.data,
          plays: p.data,
          workshops: w.data,
          achievements: a.data,
          partners: pr.data,
          content: mergeContent(c.data),
          gallery: g.data,
        });
      } catch (e) { console.error(e); }
    })();
  }, []);

  return (
    <div data-testid="home-page" className="min-h-screen bg-[#1A0F0E] text-[#D6CBBF]">
      <Navbar content={data.content} />
      <Hero settings={data.settings} content={data.content} />
      {data.content.section_order.filter((k) => !data.content.hidden_sections.includes(k)).map((k) => {
        const S = SECTIONS[k];
        return S ? <React.Fragment key={k}>{S(data)}</React.Fragment> : null;
      })}
      <Footer settings={data.settings} />
      <EasterEgg enabled={data.content.easter_egg !== false} />
    </div>
  );
}
